import styled from "@emotion/styled"
import { css } from '@emotion/react'

import facepaint from "facepaint"

const breakpoints = [440, 768, 1024, 1200, 1400]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const wrapMQ = css(mq({
  width: [
    48, // 0+
    48, // 440+
    64, // 768+
    64, // 1024+
    64, // 1200+
    64, // 1400+
  ],
  height: [
    48, // 0+
    48, // 440+
    64, // 768+
    64, // 1024+
    64, // 1200+
    64, // 1400+
  ],
  borderRadius: [
    12, // 0+
    12, // 440+
    18, // 768+
    18, // 1024+
    18, // 1200+
    18, // 1400+
  ],
  outlineOffset: [
    -5, // 0+
    -5, // 440+
    -5, // 768+
    -5, // 1024+
    -5, // 1200+
    -6, // 1400+
  ],
}))

const color = ({ color }) => {
  if (color === "red") {
    return css({
      color: "var(--color-branding)",
    })
  }
  else if (color === "indigo") {
    return css({
      color: "var(--color-indigo-400)",
    })
  }
  else if (color === "blue") {
    return css({
      color: "var(--color-dark-blue-400)",
    })
  }
  else if (color === "green") {
    return css({
      color: "var(--color-positive-700)",
    })
  }
}

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed var(--color-grayscale-500);
  outline-style: solid;
  outline-width: 1px;
  outline-color: var(--color-grayscale-500);

  & > svg {
    width: 25px;
    height: 25px;
  }

  ${color}
  ${wrapMQ}
`
